import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from '@chakra-ui/react'
import type { FC } from 'react'
import React from 'react'

interface DisconnectCalendarModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
}

const DisconnectCalendarModal: FC<DisconnectCalendarModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="16px">
        <ModalHeader
          textAlign="center"
          fontWeight="bold"
          fontSize="18px"
          pt={5}
          pb={4}
        >
          Are you sure?
        </ModalHeader>
        <ModalCloseButton top={4} right={4} />
        <ModalBody textAlign="left" pb={0}>
          <Text>
            Disconnecting ends sync and deletes this calendar's events from
            Blueprint.
            <br />
            <br />
            It may take a few minutes for events to disappear from your
            calendar.
          </Text>
        </ModalBody>
        <ModalFooter
          pb={5}
          pt={6}
          px={5}
          display="flex"
          flexDirection="row"
          gap="8px"
          width="100%"
        >
          <Button
            onClick={onClose}
            variant="outline"
            size="lg"
            borderRadius="8px"
            flex="1 1 0%"
            maxW="33.33%"
            minW={0}
          >
            Cancel
          </Button>
          <Button
            colorScheme="red"
            size="lg"
            borderRadius="8px"
            flex="2 1 0%"
            maxW="66.66%"
            minW="250px"
            onClick={onConfirm}
            isLoading={isLoading}
            bg="red.500"
            color="white"
            _hover={{ bg: 'red.600' }}
            _active={{ bg: 'red.700' }}
          >
            Disconnect calendar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default DisconnectCalendarModal
